export const E_WORDS = ['EKIPA', 'ETAPA', 'EBOLA', 'EFEKT', 'ELITA', 'EKRAN', 'ESKIM', 'ETAPA', 'EGZIL', 'EPOHA', 'ETIKA', 'ENZIM', 'EKSER']
